import { render, staticRenderFns } from "./form-client.vue?vue&type=template&id=a6b4a072&"
import script from "./form-client.vue?vue&type=script&lang=js&"
export * from "./form-client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CInput: require('@chakra-ui/vue').CInput, CFlex: require('@chakra-ui/vue').CFlex, CFormLabel: require('@chakra-ui/vue').CFormLabel, CSelect: require('@chakra-ui/vue').CSelect, CFormControl: require('@chakra-ui/vue').CFormControl, CInputGroup: require('@chakra-ui/vue').CInputGroup, CButton: require('@chakra-ui/vue').CButton, CBox: require('@chakra-ui/vue').CBox})
